import './utils/kickstart';
import { max } from 'd3-array';
import debounce from 'lodash.debounce';
import { dateParser } from './utils/d3-utils';
import { loadJsonScript } from './utils/load-json-script';
import './components/navbar';
import {
  CASES_LIGHT_BLUE,
  CASES_DARK_BLUE,
  DEATHS_LIGHT_GREY,
  DEATHS_DARK_GREY,
} from './colors';

// Translation
import { __ } from './utils/i18n';

// Generic charts
import BarTimeseries from './components/BarTimeseries.svelte';
import AreaTimeseries from './components/AreaTimeseries.svelte';
import LineTimeseries from './components/LineTimeseries.svelte';

// Custom charts
import CountiesDashboard from './components/nursinghomes/CountiesDashboard.svelte';
import NursingHomesTable from './components/nursinghomes/NursingHomesTable.svelte';
import Changelog from './components/Changelog.svelte';

///////////////////MODAL/////////////////////////////////////

var modal = document.querySelector('.m-outer-container');
import * as focusTrap from 'focus-trap'; // ESM
var contentContainer = document.querySelector('.m-content-container');
const trap = focusTrap.createFocusTrap('.m-content-container', {
  onActivate: () => contentContainer.classList.add('is-active'),
  onDeactivate: () => contentContainer.classList.remove('is-active'),
  initialFocus: () => document.querySelector('.m-content-container'),
  escapeDeactivates: false,
});

trap.activate();

// REWRITE THIS TO TARGET MAIN INSTEAD
var body = document.querySelector('body');
var main = document.querySelector('main');
var modal = document.querySelector('.m-outer-container');
var continueButton = document.querySelector('#continue-to-page');
var agreementCheckbox = document.querySelector('#agreement-checkbox');
// screenreader text w/ modal description
var screenreaderText = document.querySelector('.screenreader-text');

function freezeBody() {
  body.style.overflow = 'hidden';
  main.setAttribute('aria-hidden', 'true');
}
function unfreezeBody() {
  body.style.overflow = 'auto';
  main.setAttribute('aria-hidden', 'false');
  trap.deactivate();
  // modal?.setAttribute('aria-hidden', 'true');
}

freezeBody();
// if checkbox is checked, make "Continue to page clickable"

function toggleCheckbox(e) {
  // if it's the return key, also make it a click
  if (e.which == 13) {
    e.target.click();
  }
  let cb = e.target;
  if (cb.checked) {
    continueButton.disabled = false;

    // unlock the continue button
  } else {
    continueButton.disabled = true;
  }
}

agreementCheckbox.addEventListener('click', toggleCheckbox);
agreementCheckbox.addEventListener('keypress', toggleCheckbox);

// turn off modal when you click continue button
continueButton.addEventListener('click', function () {
  // display none on container
  modal.style.display = 'none';
  // hide screenreader text modal description from screen readers by just display none and w/ aria-hidden just in case
  screenreaderText.style.display = 'none';
  screenreaderText.setAttribute('aria-hidden', 'true');
  // un-fix background
  unfreezeBody();
});

/////////end of modal/////////////

// Load data
const statewideTimeSeriesData = loadJsonScript('statewide-timeseries-data').map(
  (d) => {
    d.date = dateParser(d.date);
    return d;
  }
);
const countyDashboardData = loadJsonScript('county-dashboard-data');
const countiesMetadata = loadJsonScript('counties-metadata');
const nursingHomesData = loadJsonScript('nursing-homes-data').sort(
  (a, b) => a.name > b.name
);

// Cumulative chart
const casesCumTarget = document.getElementById('cumulative-chart');
new LineTimeseries({
  target: casesCumTarget,
  props: {
    title: __('New cases and deaths'),
    data: statewideTimeSeriesData.filter(
      (d) =>
        d.date >= dateParser('2020-06-01') && d.deaths_nursinghomes !== null
    ),
    width: casesCumTarget.offsetWidth,
    margin: { top: 20, right: 80, bottom: 25, left: 70 },
    attrs: [
      {
        headline: __("Cumulative <span class='cases-blue'>cases</span>"),
        label: __('Cases'),
        value: 'confirmed_cases_nursinghomes',
        color: '#3995b7',
      },
      {
        headline: __("Cumulative <span class='deaths-gray'>deaths</span>"),
        label: __('Deaths'),
        value: 'deaths_nursinghomes',
        color: '#829db0',
      },
    ],
    selectedAttrIndex: 1,
    sourceline: __(
      '<a href="https://www.cdph.ca.gov/Programs/CID/DCDC/Pages/COVID-19/SNFsCOVID_19.aspx">California Department of Public Health</a>, <a href="https://www.cdss.ca.gov/">California Department of Social Services</a>'
    ),
  },
});

const newTarget = document.getElementById('new-charts-chart');
const newData = statewideTimeSeriesData.filter(
  (d) => d.date >= dateParser('2020-06-01')
);
new BarTimeseries({
  target: newTarget,
  props: {
    title: __('Cumulative cases'),
    data: newData,
    width: newTarget.offsetWidth,
    margin: { top: 20, right: 10, bottom: 25, left: 45 },
    attrs: [
      {
        headline: __('New <span class="cases-blue">cases</span> by day'),
        label: __('Cases'),
        value: 'new_confirmed_cases_nursinghomes',
        barColor: CASES_LIGHT_BLUE,
        lineColor: CASES_DARK_BLUE,
      },
      {
        headline: __('<span class="deaths-gray">Deaths</span> by day'),
        label: __('Deaths'),
        value: 'new_deaths_nursinghomes',
        barColor: DEATHS_LIGHT_GREY,
        lineColor: DEATHS_DARK_GREY,
      },
    ],
    selectedAttrIndex: 1,
    sourceline: __(
      '<a href="https://www.cdph.ca.gov/Programs/CID/DCDC/Pages/COVID-19/SNFsCOVID_19.aspx">California Department of Public Health</a>, <a href="https://www.cdss.ca.gov/">California Department of Social Services</a>'
    ),
  },
});

// Area chart
const shareTarget = document.getElementById('outsized-share-chart');
const shareData = statewideTimeSeriesData.filter((d) => d.deaths_nursinghomes);
shareData.forEach((d) => {
  d['other_deaths'] = d['reported_deaths'] - d['deaths_nursinghomes'];
  d['other_confirmed_cases'] =
    d['reported_and_probable_cases'] - d['confirmed_cases_nursinghomes'];
});
new AreaTimeseries({
  target: shareTarget,
  props: {
    title: __('Nursing home percentage of cases and deaths as of January 2023'),
    data: shareData,
    width: shareTarget.offsetWidth,
    attrs: [
      {
        headline: __(
          'Cases at <span class="cases-blue">nursing homes</span> vs. <span class="cases-light-blue">elsewhere</span>'
        ),
        label: __('Cases'),
        value: 'cases',
        maxValue: max(shareData, (d) => d.reported_and_probable_cases),
        layers: [
          {
            value: 'confirmed_cases_nursinghomes',
            color: '#3995b7',
          },
          {
            value: 'other_confirmed_cases',
            color: '#c0e9f3',
          },
        ],
      },
      {
        headline: __(
          'Deaths at <span class="deaths-gray">nursing homes</span> vs. <span class="deaths-light-gray">elsewhere</span>'
        ),
        label: __('Deaths'),
        value: 'deaths',
        maxValue: max(shareData, (d) => d.reported_deaths),
        layers: [
          {
            value: 'deaths_nursinghomes',
            color: '#829db0',
          },
          {
            value: 'other_deaths',
            color: '#c2cad3',
          },
        ],
      },
    ],
    selectedAttrIndex: 1,
    sourceline: __('California Department of Public Health'),
  },
});

// County dashboard
new CountiesDashboard({
  target: document.getElementById('california-map-container'),
  props: {
    data: countyDashboardData.sort(
      (a, b) => b['confirmed_cases'] - a['confirmed_cases']
    ),
    metadata: countiesMetadata,
  },
});

// Boot tables
new NursingHomesTable({
  target: document.getElementById('skilled-nursing-container'),
  props: { data: nursingHomesData.filter((d) => d.type == 'skilled-nursing') },
});

new Changelog({
  target: document.getElementById('changelog-container'),
  props: loadJsonScript('changelog-data'),
});
